export const attributeTypeCodes = {
  T_SHORT: 'T_SHORT',
  T_RICH: 'T_RICH',
  TEXT: 'TEXT',
  LINK: 'LINK',
  NUM_TXT: 'NUM_TXT',
  LIST: 'LIST',
  F_IMG: 'F_IMG',
  F_GEN: 'F_GEN',
  F_LS_IMG: 'F_LS_IMG',
  BOOL: 'BOOL',
}
